import * as React from 'react'
import Svg, { SvgProps, Circle, Path } from 'react-native-svg'

const RescuePending = (props: SvgProps) => (
  <Svg width="46" height="46" fill="none" viewBox="0 0 32 32" {...props}>
    <Circle cx="16" cy="16" r="13.638" stroke="#7D8893" strokeWidth="1.524" />
    <Path
      stroke="#7D8893"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.286"
      d="m20.159 13.304-8.46 5.542M17.379 20.07l-5.68-1.224 1.242-5.76"
    />
    <Circle cx="25.143" cy="25.143" r="6.095" fill="#D68E38" />
    <Circle cx="24.713" cy="24.891" r="0.774" fill="#fff" />
    <Circle cx="27.442" cy="24.988" r="1.064" fill="#fff" />
    <Circle cx="22.066" cy="24.891" r="0.58" fill="#fff" />
  </Svg>
)

export default RescuePending
